import mainApi from '../../services/mainApi'
import config from './../../config'

const SET_DATA = "SET_DATA"

const state = {
	data: null,
	// baseUrl: 'http://localhost:8000',
	// baseUrl: 'https://dafdukapi.laksitastartup.com',
	baseUrl: config.baseUrl,
	appName: config.appName,
	appVersion: config.appVersion,
}

const mutations = {
	[SET_DATA](state, data) {
		state.data = data
	}
}

const actions = {
	async fetchData() {
		return await mainApi.get()
	},
	showPageLoader() {
		// hanya bisa jalan on mounted
		// spinner
		const loader = document.createElement('div')
		loader.innerHTML = '<div class="overlay-page-loader"><div class="spinner"></div></div>'
		document.querySelector('#app').appendChild(loader)

		// jaga jaga siapa tau gak ilang spinnernya
		setTimeout(() => {
			if (document.querySelector('.overlay-page-loader')) {
				document.querySelector('.overlay-page-loader').remove()
			}
		}, 1000)
		// console.log('ok')

		return true
	},
	async fetchAppVersion() {
		return await mainApi.fetchAppVersion()
	},
}

const getters = {
	getBaseUrl: state => {
		return state.baseUrl
	},
	getAppName: state => {
		return state.appName
	},
	getAppVersion: state => {
		return state.appVersion
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}